import { DetailedProject } from '@/domain/project/types';
import Link from '@/lib/translation/components/link';

import { getDomainOfUrl } from '@/lib/url';

interface NewsCardProps {
  pressElement: DetailedProject['press'][0];
}

const NewsCard = ({
  pressElement: { url, title, content, date },
}: NewsCardProps) => {
  if (url) {
    return (
      <Link
        className="mr-8 flex h-fit flex-100 flex-col content-center gap-4 rounded-2xl bg-primary-50 p-6 lg:flex-40"
        href={url}
        target="_blank"
        rel="nofollow"
      >
        <div className="w-fit rounded-3xl border bg-secondary px-2 py-1 text-sm font-bold uppercase text-white">
          {getDomainOfUrl(url)}
        </div>
        <div className="text-left text-xl font-bold">{title}</div>
        <div className="text-left text-base">{content}</div>
        <div className="text-left text-xs">{date}</div>
      </Link>
    );
  }
  return (
    <div className="mr-8 flex h-fit flex-100 flex-col content-center gap-4 rounded-2xl bg-primary-50 p-6 lg:flex-40">
      <div className="text-left text-xl font-bold">{title}</div>
      <div className="text-left text-base">{content}</div>
      <div className="text-left text-xs">{date}</div>
    </div>
  );
};

export default NewsCard;
